export default __webpack_public_path__ + "static/media/copy-icon.30336dfb.svg";